"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function () {
  return {
    box: {
      display: 'flex',
      height: '100vh',
      maxHeight: '100vh',
      textAlign: 'center',
      width: '100%'
    }
  };
});
exports.default = useStyles;